import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ValidationService } from '../../services/formsValidation/validation.service';
import { FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogConfig } from "@angular/material";
import { BorrowerRenderingService } from '../../services/borrower/borrower-rendering.service';
import { OTP } from '../../models/OTP/OTP';
import { NgxSpinnerService } from 'ngx-spinner';
import { OTPformBuilderService } from '../../services/formsValidation/otpform-builder.service';
import { DLPRestUtilityService } from '../../services/rest/dlprest-utility.service';
import { HttpErrorResponse } from '@angular/common/http';
import { QuoteRenderingService } from '../../services/search/quote-rendering.service';
import { NewQuote } from '../../models/search/new-quote';
import { DialogBoxComponent } from '../dialog-box/dialog-box.component';
import { BorrowerDTO } from '../../models/borrower/borrower-dto';
import { OTPLaterLabel_EN } from '../../models/labels/OTPLaterLabel_EN';
import { SearchResultLabel_EN } from '../../models/labels/searchResultLabel_EN';
import { FooterLabel_EN } from '../../models/labels/footerLabel_EN';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { IncomeDTO } from 'src/app/models/borrower/income-dto';
import { LoanStep1 } from 'src/app/models/borrower/loan-step1';
import { LoanStep2 } from 'src/app/models/borrower/loan-step2';
import { LoanStep3 } from 'src/app/models/borrower/loan-step3';
import { LoanStep4 } from 'src/app/models/borrower/loan-step4';
import { Parameter } from 'src/app/models/borrower/loanFormParameter';
import { QuotationEntityIdDto } from 'src/app/models/search/quotation-entity-id-dto';
import { SearchQuote } from 'src/app/models/search/search-quote';
import { submitOTPLabel_EN } from 'src/app/models/labels/submitOTPLabel_EN';


@Component({
  selector: 'app-submit-otp-later',
  templateUrl: './submit-otp-later.component.html',
  styleUrls: ['./submit-otp-later.component.scss']
})
export class SubmitOtpLaterComponent implements OnInit {

  onRegenerate = new EventEmitter();
  otp: OTP;
  errormessage: string;
  otpForm: FormGroup;
  otpFormErrors: any = {};
  otpField1: string = '';
  otpField2: string = '';
  otpField3: string = '';
  otpField4: string = '';
  otpField5: string = '';
  otpField6: string = '';
  autoFocus: boolean = true;
  validOtp: boolean = false;
  searchResult: NewQuote;
  primaryBorrower: BorrowerDTO
  applicationNumber: string = " ";
  label: any;
  labelOtp: any;
  searchLabel: any;
  footerLabel: any;
  show: boolean = true;

  constructor(
    private OTPformBuilder: OTPformBuilderService,
    private validationService: ValidationService,
    private router: Router,
    private quoteRenderingService: QuoteRenderingService,
    private dlpRestUtilityService: DLPRestUtilityService,
    private borrowerRenderingService: BorrowerRenderingService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.otp = this.borrowerRenderingService.OTP;
    this.searchResult = this.quoteRenderingService.newQuote;
    this.primaryBorrower = this.borrowerRenderingService.primaryBorrower;
    this.buildForm();
    this.label = new OTPLaterLabel_EN();
    this.labelOtp = new submitOTPLabel_EN();
    this.searchLabel = new SearchResultLabel_EN();
    this.footerLabel = new FooterLabel_EN();
  }

  buildForm() {
    this.otpForm = this.OTPformBuilder.buildOTPForm(this.otpForm, this.otp,false);
    this.otpFormErrors = this.createFormError(this.otpForm);
    this.otpForm.valueChanges.subscribe((data) => {
      this.otpFormErrors = this.validationService.validateForm(this.otpForm, this.otpFormErrors, true);
    });
  }

  createFormError(formGroup: FormGroup) {
    let formErrors: any = {};
    let controls = formGroup.getRawValue();
    Object.keys(controls).forEach(control => {
      formErrors[control] = '';
    })
    return formErrors;
  }

  getPrimaryBorrowerName() {
    let name: string = '';
    if (this.primaryBorrower.firstName) {
      name = this.primaryBorrower.firstName;
    }
    if (this.primaryBorrower.middleName) {
      name = name + " " + this.primaryBorrower.middleName;
    }
    if (this.primaryBorrower.lastName) {
      name = name + " " + this.primaryBorrower.lastName;
    }
    return name;
  }

  getDlpRefNum() {
    return this.borrowerRenderingService.primaryBorrower.cstCustomerEntityId.custId;
  }

  focusOnField() {
    if (this.autoFocus == false) {
      this.autoFocus = true;
    }
  }

  validation(event) {
    if (this.otpForm.invalid) {
      this.errormessage = "Please enter Valid OTP"
    }
    else if (this.otpForm.valid) {
      this.errormessage = " ";
    }
  }


  onSubmit() {
    {
      this.spinner.show();
      this.otp.otp = +(this.otpField1 + this.otpField2 + this.otpField3 + this.otpField4 + this.otpField5 + this.otpField6);
      this.otp.quotStatusId = "TRACK_APPLN";
      this.otp.quotationNumber = this.borrowerRenderingService.loanStep2.indusRefId;
      this.otp.indCustQuotOtpId.custId = this.borrowerRenderingService.primaryBorrower.cstCustomerEntityId.custId;
      this.otp.indCustQuotOtpId.portfolioId = this.quoteRenderingService.quotation.portfolioId;
      this.otp.indCustQuotOtpId.quotationId = this.quoteRenderingService.quotation.quotationId;
      this.dlpRestUtilityService.sendOtp(this.otp)
        .subscribe(res => {
          let data: any = res;
          if (data.applicationNumber) {
            this.applicationNumber = data.applicationNumber;
          } else {
            this.applicationNumber = this.borrowerRenderingService.primaryBorrower.cstCustomerEntityId.custId;
          }
          this.show = false;
          this.spinner.hide();
        },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              //A client-side or network error occurred.				 
              console.log('An error occurred:', err.error.message);
            } else {
              //  Backend returns unsuccessful response codes such as 404, 500 etc.
              console.log('Backend returned status code: ', err.status);
              console.log('Response body:', err.error);
              this.errormessage = err.error.errorMessage;
              if (err.error.uniqueId == 60002) {
                this.otpForm.reset();
              }
            }
            this.spinner.hide();
          }
        );
    }

  }



  onChange(event: any) {
    this.otpFormErrors = this.validationService.validateField(this.otpForm.controls[event.srcElement.id] as FormControl,
      this.otpFormErrors, event.srcElement.id, false);
    this.errormessage = this.otpFormErrors[event.srcElement.id];
    let element;
    if (event.key != "Backspace") {
      element = event.srcElement.nextElementSibling; // get the sibling element

      if (element == null)  // check if its null
        return;
      else
        element.focus();   // focus if not null
    }
    else if (event.key == "Backspace") {
      element = event.srcElement.previousElementSibling;
      if (element == null)  // check if its null
        return;
      else
        element.focus();
    }
  }

  resendOTP() {
    this.spinner.show();
    this.otpForm.reset();
    this.otp.otp = +(this.otpField1 + this.otpField2 + this.otpField3 + this.otpField4 + this.otpField5 + this.otpField6);
    this.otp.quotStatusId = "OTP_ENTERED";
    this.otp.quotationNumber = this.borrowerRenderingService.loanStep2.indusRefId;
    this.otp.indCustQuotOtpId.custId = this.borrowerRenderingService.primaryBorrower.cstCustomerEntityId.custId;
    this.otp.indCustQuotOtpId.portfolioId = this.quoteRenderingService.quotation.portfolioId;
    this.otp.indCustQuotOtpId.quotationId = this.quoteRenderingService.quotation.quotationId;
    this.dlpRestUtilityService.resendOtp(this.otp).subscribe(res => {
      this.spinner.hide();
    },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          //A client-side or network error occurred.				 
          console.log('An error occurred:', err.error.message);
        } else {
          //  Backend returns unsuccessful response codes such as 404, 500 etc.
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);
          this.errormessage = err.error.errorMessage;
          this.otpForm.reset();
        }

      }
    );
    this.spinner.hide();
  }

  review() {
    this.router.navigate(['/form/review']);
  }

  openOtpDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'my-class';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      type: 'sumbitOtpLater',

    };
    const dialogRef = this.dialog.open(DialogBoxComponent, dialogConfig);
  }

  validOtpSubmit() {
    this.quoteRenderingService.newQuote = new NewQuote();
    this.borrowerRenderingService.primaryBorrower = new BorrowerDTO();
    this.borrowerRenderingService.incomeBorrower = new IncomeDTO();
    this.borrowerRenderingService.loanStep1 = new LoanStep1();
    this.borrowerRenderingService.loanStep2 = new LoanStep2();
    this.borrowerRenderingService.loanStep3 = new LoanStep3();
    this.borrowerRenderingService.loanStep4 = new LoanStep4();
    this.borrowerRenderingService.parameter = new Parameter();
    this.borrowerRenderingService.coApplicantBorrower = new BorrowerDTO();

    this.quoteRenderingService.quotation = new QuotationEntityIdDto();
    this.quoteRenderingService.searchQuote = new SearchQuote();
    this.router.navigate(['/home']);
  }

}
